import React from "react"
import "../../styles/Common/TextMultiStyle.less"
import DOMPurify from "dompurify"

export default function TextMultiStyle(props) {
  return (
    <div onClick={props.onClick}>
      <div className={props.StyleText} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.text) }}></div>
    </div>
  )
}
